import { useEffect } from "react";
import { useInView } from "react-intersection-observer";
import useGetAllPointsHistory from "../../hooks/useGetAllPointsHistory";
import Spinner from "../spinner/Spinner";
import styles from "./PointsHistoryListStyles.module.css";

type PointsHistoryEntry = {
  pointsId: number;
  senderId: number;
  receiverId: number;
  givenPoints: number;
  createdAt: string;
  sender: {
    id: number;
    preferredName: string;
    lastName: string;
    email: string;
  };
  receiver: {
    id: number;
    preferredName: string;
    lastName: string;
    email: string;
  };
};

const PointsHistoryList = () => {
  const { ref, inView } = useInView();
  const { data, isLoading, isFetchingNextPage, hasNextPage, fetchNextPage } =
    useGetAllPointsHistory();

  const historyList: PointsHistoryEntry[] =
    data?.pages.flatMap((page: any) => page.pointsHistory) || [];

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, isFetchingNextPage, hasNextPage, fetchNextPage]);

  return (
    <div className={styles.manageAddOnListBlk}>
      <div className={styles.manageProductBlkTitle}>
        <h1>Points History</h1>
      </div>

      <div className={styles.addOnListMainContainer}>
        {isLoading ? (
          <div style={{ display: "block", padding: "10px 0" }}>
            <Spinner variant="medium-spinner" alignSpin="center-spinner" />
          </div>
        ) : historyList.length === 0 ? (
          <p className={styles.notAvailableBlkTxt}>
            No points history records available
          </p>
        ) : (
          <table className={styles.accessibleTable} aria-label="Points History">
            <thead>
              <tr>
                <th scope="col">Sender</th>
                <th scope="col">Receiver</th>
                <th scope="col">Points</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              {historyList.map((entry: PointsHistoryEntry) => (
                <tr key={entry.pointsId}>
                  <td>
                    {entry.sender?.preferredName} {entry.sender?.lastName}
                  </td>
                  <td>
                    {entry.receiver?.preferredName} {entry.receiver?.lastName}
                  </td>
                  <td>
                    <span className={styles.pointsBadge}>
                      {entry.givenPoints}
                    </span>
                  </td>
                  <td>
                    {entry.createdAt
                      ? new Date(entry.createdAt).toLocaleString()
                      : "-"}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
        <div ref={ref} style={{ height: "1px" }}></div>
        {isFetchingNextPage && (
          <div style={{ display: "block", padding: "20px 0px" }}>
            <Spinner variant="medium-spinner" alignSpin="center-spinner" />
          </div>
        )}
      </div>
    </div>
  );
};

export default PointsHistoryList;
